<template>
	<div class="card-edit viewer-card" v-show="!isViewerActive">
		<o-loading :full-page="true" :active="isLoading || !dataLoaded" :can-cancel="false"></o-loading>
		<div class="viewer-card-header">
			  <nav class="navbar" role="bim-viewer-card" aria-label="bim-viewer-card">
					<div class="navbar-menu is-align-items-center">
						<div class="navbar-start">
							<i class="icon-productionorderOL has-text-black-bis"></i>
							<div class="is-divider-vertical my-0"></div>
							<div class="has-text-black-bis">
								<h6 class="is-size-6 sub-header has-text-weight-semibold mb-1 mt-1">CREATE PRODUCTION ORDERS</h6>
								<h6 class="is-size-6 has-text-weight-semibold has-text-grey">ADD MODEL OBJECT GROUPS</h6>
							</div>
						</div>
					</div>
					<div class="navbar-end" >
						<div class="is-divider-vertical  my-1"></div>
						<div class="navbar-item">
							<a :href="openBIMPLUS()" target="_blank" class="has-text-black-bis"><i class="icon-bimplus"></i></a>
						</div>
					</div>
				</nav>
		</div>
		<div class="card-basic p-3">
			<div class="column">
				<div class="columns">
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label ">
									Manufacton Project:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">{{ selectedProject?.name }}</span>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-8">
								Stage:
							</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">Detailing</span>
							</div>
						</div>
					</div>
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label">BIMPLUS Model:</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3" v-if="!$_.isEmpty(modelName)">
									{{ modelName }}
								</span>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-4">Model Source:</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3">
									{{ isSDS2 ? 'SDS2' : 'Other' }}
								</span>
							</div>
						</div>			
					</div>
					<div class="column">
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label">
									Object Grouping:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3" v-if="!isSDS2">
								{{  objGrpVal }}
								</span>
								<div v-else>
									<mf-multi-select
										:modelValue="groupOrderBy"
										track-by="value"
										label="label"
										:multiple="false"
										:options="objectGroupingOpts"
										:allow-empty="false"
										:closeOnSelect="true"
										@update:modelValue="groupOrder($event)">
									</mf-multi-select>
								</div>
							</div>
						</div>
						<div class="columns">
							<div class="column is-narrow">
								<label class="has-text-black-bis is-italic is-size-3 label mr-4">
									Item Grouping:
								</label>
							</div>
							<div class="column">
								<span class="has-text-black-bis is-size-3"  v-if="isSDS2">
								Manufacton Assemblies
								</span>
								<div v-else>
									<mf-multi-select
										:modelValue="groupItemBy"
										track-by="value"
										label="label"
										:multiple="false"
										:options="itemGroupingOpts"
										:allow-empty="false"
										:closeOnSelect="true"
										@update:modelValue="groupItem($event)">
									</mf-multi-select>
								</div>
							</div>
						</div>
					</div>
			  </div>
			</div>
		</div>
		<div class="is-divider my-2"></div>
		<div class="edit-body table-container has-background-white pr-4">
			<mf-table
				ref="BIMPLUSOrderTable"
				:rowData="creationData"
				:tableProps="orderTableProps"
				:loadData="loadData"
				:hideGutter="true"
				:apiMode="true"
				:isBimPlus ="true"
				:isSDS2="isSDS2"
				:key="rerenderOrderMfTable"
				:checkedRows="selectedItems"
				:selectedRow="selectedRow"
				:project="selectedProject"
				@row-select="getSelectedRows($event)"
				@opened-row="getDetailRowOrder($event)"
				@checkbox-toggled="getSelectedRows"
				@cell-clicked="onCellClicked"
				@refreshTable="rerenderOrderMfTable++">
				<template #itemSelect="{ rowData }">
					<div class="is-clickable is-flex is-align-items-center is-justify-content-center"
						@click="loadItems(rowData)">
							<i :class="rowData.itemLoad ? 'icon-attacheditems icon-dark' : 'icon-attacheditemsOL'" ></i>
					</div>
				</template>
				<template #viewBIM="{ rowData }">
					<div  @click="loadBIMPLUS(rowData)" class="is-clickable is-flex is-align-items-center is-justify-content-center">
						<i class="icon-show"></i>
					</div>
				</template>
				<template #notes="{ rowData }">
					<div @click="editDocs(rowData)" :disabled="true" class="is-clickable is-flex is-align-items-center is-justify-content-center">
						<i :class="rowData.files ? 'icon-attacheddocuments' : 'icon-attacheddocumentsOL'"></i>
					</div>
				</template>
				<template #templateSelect="{ rowData, rowField }">
					<SelectOptions v-model="rowData.template"
						:options="templateOrders" :key="refreshTemplate"
						@update:modelValue="$event => onTemplateChange(rowData, $event)">
					</SelectOptions>
				</template>
				<template #shipBy="{ rowData, rowField }">
          <select-date-popup-field
            :rowData="rowData"
            :rowField="rowField"
						:key="refreshCount"
						:isBIMPLUS="true"
						:isDateDisabled="dateDisable(rowData, rowField)"
            @selected-date="updateDate"/>
        </template>
        <template #deliverBy="{ rowData, rowField }">
          <select-date-popup-field
            :rowData="rowData"
            :rowField="rowField"
						:key="refreshCount"
						:isBIMPLUS="true"
						:isDateDisabled="dateDisable(rowData, rowField)"
            @selected-date="updateDate"/>
        </template>
				<template v-slot:owner-select="{ rowData }">
					<SelectOptions v-model="rowData.owner"
						:options="allUsers" :key="refreshOwner"
						@update:modelValue="$event => setOwner(rowData, $event)">
					</SelectOptions>
				</template>
				<template v-slot:location-select="{ rowData }">
					<SelectOptions v-model="rowData.location"
						:options="allLocations" :key="refreshLocation"
						@update:modelValue="$event => setLocation(rowData, $event)">
					</SelectOptions>
				</template>
				<template v-slot:level-select="{ rowData, rowField }">
					<LvlZone :key="refreshlevel"
						:value="rowData.level"
						:rowData="rowData"
						:rowField="rowField"
						@updateLvlZone="updateLvlZone(rowData, rowField, $event)"
						:isBIMPLUS="true">
					</LvlZone>
				</template>
				<template v-slot:zone-select="{ rowData, rowField }">
					<LvlZone :key="refreshlevel"
						:value="rowData.zone"
						:rowData="rowData"
						:rowField="rowField"
						@updateLvlZone="updateLvlZone(rowData, rowField, $event)"
						:isBIMPLUS="true">
					</LvlZone>
				</template>
			</mf-table>
		</div>
		<div class=" edit-body table-container has-background-white pr-4 viewer-order-item">
			<h3 class="has-text-black-bis is-size-3 is-align-items-center is-flex mb-3">
				<i class="icon-attacheditems mr-1"></i><span class="has-text-weight-semibold is-italic  mr-2">Production Order Items:</span> <span>{{ loadItemData?.name }}</span>
			</h3>
			<mf-table
				ref="BIMPLUSItemTable"
				:tableProps="itemTableProps"
				:loadData="loadItemsData"
				:hideGutter="true"
				:isBimPlus="true"
				:apiMode="true"
				:key="rerenderMfTable"
				@cell-clicked="onItemCellClicked"
				@refreshTable="rerenderMfTable++">
				<template #templateSelect="{ rowData, rowField }">
					<SelectOptions v-model="rowData.template"
						:options="matTemplateOrders" :key="refreshTemplate"
						@update:modelValue="$event => onTemplateChange(rowData, $event)">
					</SelectOptions>
				</template>
			  	<template #viewBIM="{ rowData }">
					<div  @click="loadBIMPLUS(rowData)" class="is-clickable is-flex is-align-items-center is-justify-content-center">
						<i class="icon-show"></i>
					</div>
				</template>
				<template #notes="{ rowData }">
					<div @click="editDocs(rowData)" :disabled="true" class="is-clickable is-flex is-align-items-center is-justify-content-center">
						<i :class="rowData.files ? 'icon-attacheddocuments' : 'icon-attacheddocumentsOL'"></i>
					</div>
				</template>
			</mf-table>
		</div>
		<footer class="card-footer is-justify-content-flex-end is-align-items-center has-background-white p-5">
			<div class="">
				<button class="button is-outlined mr-2" @click="close()">
					Cancel
				</button>
				<button class="button has-background-black-bis has-text-white" :disabled="$_.isEmpty(selectedItems)" @click="save()">
					Create Order(s)
				</button>
			</div>
		</footer>
	<Documents v-if="docsEdit"
		:isActive="docsEdit"
		:rowData="docs"
		modalHeader="Add Documents"
		:orderTitle="docsOrderTitle"
		:isBIMPLUS="true"
    @close="closeDocsModal">
	</Documents>
	</div>
	<BimPlusViewerVue v-if="isViewerActive"
		:projectId="projectId"
		:guids="guids"
		:isolateView="true"
		:modelName="modelName"
		:orderName="orderForViewer.name"
		@back="closeViewer"/>
	<o-modal :active="isProgressBar" v-if="isProgressBar"  :canCancel="false" class="modal-xs">
		<progress-bar
			:totalCount="selectedItems.length"
			:progressCount="progressCount"
			headerLabel= "Creating BIMPLUS Orders"
			@turn-off-progress="turnOffProgress"
			progressType="percent"
			progressLabel="Created"
		/>
	</o-modal>
	<excel-invalid-data
			:isActive="isInvalidModalActive"
			:loadData="loadInvalidData"
			:tableCols="invalidListCols"
			@close="closeInvalidListModal"
			:key="invalidRefreshKey"
			:isBIMPLUS="true"
			:hasErrorOccured="hasErrorOccured"></excel-invalid-data>
</template>
<script>

import { computed, onBeforeMount, reactive, toRefs, inject, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { chunk, every, filter, find, findIndex, get, groupBy, isEmpty, isNumber, toUpper, uniq } from 'lodash';
import { useToast } from 'vue-toastification';
import router from '../router';
import { DialogProgrammatic } from '@/components/Dialog';
import moment from 'moment';

import createBIMOrderCols from '@/components/table-cols/createBIMOrderCols';
import createBimItemCols from '@/components/table-cols/createBimItemCols';
import validationListCols from '@/components/table-cols/validationListBIMPLUSCOLS.js';

import MfTable from '@/components/table-fields/MfTable.vue';
import TemplateSelect from '@/components/fields/TemplateSelect.vue';
import MfDate from '@/components/abstract/MfDate.vue';
import Documents from '@/components/modals/TableDocuments.vue';
import BimPlusViewerVue from '@/views/bimplus/BimPlusViewer.vue';
import ExcelInvalidData from '@/components/modals/ExcelInvalidData.vue';
import CustomDatePicker from '@/components/CustomDatePicker.vue';
import UtilityMixin from './mixins/UtilityMixin';
import ProgressBar from '@/components/modals/ProgressBar'
import bimplusViewer from '../views/bimplus/bimplusViewer';
import SelectOptions from '@/components/abstract/SelectOptions.vue';
import SelectDatePopupField from '@/components/fields/SelectDatePopupField.vue'
import LvlOrZoneField from '@/components/fields/LvlOrZoneField.vue';

import Projects from '@/models/Projects';
import ProductionManager from '@/models/ProductionManager';
import SupplyChain from '@/models/SupplyChain';
import Locations from '@/models/Locations';
import urls from '@/urls';
import Validations from '@/models/Validations';
import Validation from '@/components/utils/Validations';
import BimPlus from '@/models/BimPlus';
import Catalogs from '@/models/Catalogs';

export default {
	name: 'CreateBIMOrder',
	props: {
    projectId: {
      type: String,
      default: '',
    },
    models: {
      type: Array,
      required: true
    },
  },
	components: {
		'mf-table': MfTable,
		'template-select': TemplateSelect,
		'mf-date': MfDate,
		'progress-bar': ProgressBar,
		Documents,
		BimPlusViewerVue,
		'excel-invalid-data': ExcelInvalidData,
		'custom-date-picker': CustomDatePicker,
		SelectOptions,
		'select-date-popup-field': SelectDatePopupField,
		'LvlZone': LvlOrZoneField,
	},
	setup(props, { emit }) {
		const emitter = inject('emitter');
		const route = useRoute();
		const store = useStore();
		const toast = useToast();
		const BIMPLUSOrderTable = ref(null);
		const BIMPLUSItemTable = ref(null);
		const invalidListCols = computed(() => validationListCols);
		const { getAllLocations } = UtilityMixin();
		const itemGroupingOpts = [
			{ label: 'Individual Manufacton Items', value: 'group-Individual' },
			{ label: '(1) Manufacton Item', value: 'group-single' },
			{ label: 'Manufacton Assemblies', value: 'group-Assemblies' },
		];
		const objectGroupingOpts = [
			{ label: 'Name', value: 'name' },
			{ label: 'PieceMark', value: 'piecemark' },
			{ label: 'Member category', value: 'member category' },
			{ label: 'Member description', value: 'member description' },
			{ label: 'Member sequence', value: 'member sequence' },
			{ label: 'Package Number', value: 'package number' },
			{ label: 'Shop Sequence Number', value: 'shop sequence number' },
		]
		const state = reactive({
			rerenderMfTable: 0,
			rerenderOrderMfTable: 0,
			orderTableProps: createBIMOrderCols,
			itemTableProps: createBimItemCols,
			templateProject: {},
			templateOrders: [],
			matTemplateOrders: [],
			allLocations: [],
			creationData: [],
			selectedOrder: null,
			itemLoad: false,
			allUsers: [],
			isLoading: false,
			progressCount: 0,
			totalProgressLength: 0,
			isProgressBar: false,
			selectedItems: [],
			selectedRow: {},
			groupedData: {},
			groupItemBy: itemGroupingOpts[0],
			groupOrderBy: objectGroupingOpts[0],
			itemsData: null,
			elementsData: null,
			selectedProject: null,
			isSDS2: false,
			existingCatIds: null,
			docsEdit: false,
			docs: {},
			createBOM: false,
			loadItemData: null,
			dataLoaded: false,
			isViewerActive: false,
			guids: [],
			orderForViewer: {},
			selectedProjectUser: null,
			invalidData: [],
			invalidRefreshKey: 0,
			docsOrderTitle: null,
			isInvalidModalActive: false,
			team_slug: '',
			page: 1,
			showItemTable: false,
			refreshCount: 0,
			refreshOwner: 0,
			refreshLocation: 0,
			refreshTemplate: 0,
			searchedData: [],
			refreshlevel: 0,
			enableGrouping: false,
			hasErrorOccured: false,
		});
		const addBimplusDocs = async(order) => {
			try {
				for(const item of order.items){
					const files = await bimplusViewer.getElementAttachments((item.guids[0].guid.split('*'))[1], state.team_slug);
					if (!item?.isBIMDocsAdded && !isEmpty(files)) {
						for(const f of files){
							if(!item.files) item.files = [];
								const fileObj = {
									"sources": [
										{
											"_id": order.uuid, // order uuid
											"type": "order",
											"stage": "detailing"
										},
										{
											"uuid": item.uuid, //item uuid
											"type": "item",
											"stage": "detailing"
										}
									],
									"archived": {
											"value": false
									},
									"url": `${state.team_slug}/attachments/${f.id}`, // pdf id or ncl id
									"name": f.fileName,
									"isPrivate": true,
									"type": "bimPlus",
									"visible": "to-me",
								}
								item.files.push(fileObj)
						}
						item.isBIMDocsAdded = true;
					}
				}
			} catch (error) {
				console.log('Error:', error);
			}
		}
		const getSelectedRows = (orders) => {
			state.selectedItems = orders;
			for(const order of orders){
				addBimplusDocs(order);
			}
		};
								
		const loadData = async (params) => {
			try {
				if (state.selectedProject) {
					state.isLoading = true;
					if ((isEmpty(state.creationData) || state.enableGrouping) && state.page === 1) {
						let edata;
						let finData = [];
						let materialData = [];
						const orderGroupingProperty = state.isSDS2 ? state.groupOrderBy?.value : state.selectedProject.projectSettings[0].bimplusBindings.groupingProperties[0].value.toLowerCase();
						const filteredElementsData = ['piecemark', 'member sequence'].includes(orderGroupingProperty) ? state.elementsData : filter(state.elementsData, (element) => {
							let orderPath;
							let [groupingPath] = Object.keys(element.attributes).filter((key) => {
								orderPath = find([element.attributes[key]], orderGroupingProperty)
								if (orderPath) return key;
							})
							if (!isEmpty(groupingPath)) return element;
						});
						if (isEmpty(filteredElementsData)) {
							toast.error('Please use/enter valid Object Grouping property');
							return {};
						}
						const itemGroupingProperty = state.selectedProject.projectSettings[0].bimplusBindings.bimplusProperties[0].value.toLowerCase();
						if (state.isSDS2) {
							edata = groupBy(filteredElementsData, (element) => {
								let orderPath;
								let [groupingPath] = Object.keys(element.attributes).filter((key) => {
									orderPath = find([element.attributes[key]], 'piecemark')
									if (orderPath) return key;
								})
								if (!isEmpty(groupingPath)) return `element.attributes.${groupingPath}.piecemark`;
							});
							for (let [key, val] of Object.entries(edata)) {
								if (key !== 'undefined') finData.push(...val);
								else if (key === 'undefined') materialData.push(...val);
							}
							edata = finData;
						} else edata = filteredElementsData;
						const orderParams = {
							elementsData: edata,
							orderGroupingProperty: orderGroupingProperty,
							isSDS2: state.isSDS2,
							selectedProject: state.selectedProject,
							materialData: materialData,
							modelId: route.query.modelId,
							owner: state.selectedProjectUser,
							itemGroupingProperty: itemGroupingProperty,
							itemGroupingType: state.groupItemBy?.value,
						}
						const { creationData, groupedData } = await bimplusViewer.groupOrders(orderParams);
						state.creationData = creationData;
						state.groupedData = groupedData;
						state.enableGrouping = false;
						if(isEmpty(state.creationData) && isEmpty(state.groupedData)) {
							toast.error('Please use/enter valid Object Grouping property');
							return {};
						}
					}
					const chunkedData = chunk(state.creationData, 25);
					if (params?.search) {
						const itemActiveOrder = find(chunkedData[state.page - 1], (order) => order.itemLoad)
						if (!isEmpty(itemActiveOrder)) {
							state.loadItemData = null;
							itemActiveOrder.itemLoad = false;
						}
						state.searchedData = filter(state.creationData, (d) => {
							return isNumber(d.name) ? d.name.toString().includes(params.search.toString()) : d.name.toLowerCase().includes(params.search.toLowerCase());
						})
						return { data: state.searchedData, total: state.searchedData.length };
					}
					return { data: chunkedData[state.page - 1], total: state.creationData.length };
				} else {
					return {};
				}
			} catch (e) {
				console.log('Error: ', e);
			} finally {
				state.isLoading = false;
			}

		}

		const loadItemsData = async () => {
			try {
				state.isLoading = true;
				if (!isEmpty(state.loadItemData) && state.loadItemData?.itemLoad && !isEmpty(state.loadItemData.items) && !state.isSDS2) {
					return {data: state.loadItemData.items, total: state.loadItemData.items.length};
				} else if (!isEmpty(state.loadItemData) && state.loadItemData?.itemLoad && !isEmpty(state.loadItemData.items) && state.isSDS2) { 
					return {data: state.loadItemData.items, total: state.loadItemData.items.length};
				} else return {};
			} catch (error) {
				console.log('Error:', error)
			} finally {
				state.isLoading = false;
			}
		};

		const groupOrder = async (event) => {
			state.page = 1;
			state.enableGrouping = true;
			state.selectedItems = [];
			state.groupOrderBy = event;
			state.loadItemData = null
			state.rerenderOrderMfTable++;
			state.rerenderMfTable++;
		};

		const groupItem = async (event) => {
			try {
				state.isLoading = true;
				state.groupItemBy = event;
				const itemGroupingProperty = state.selectedProject.projectSettings[0].bimplusBindings.bimplusProperties[0].value.toLowerCase();
				const params = {
					orderDetails: state.creationData, 
					groupedData: state.groupedData,  
					itemGroupingType: state.groupItemBy?.value, 
					itemGroupingProperty: itemGroupingProperty,
					elementsData: state.elementsData,
				}
				await bimplusViewer.groupItems(params);
			} catch (error) {
				console.log('Error:', error)
			} finally {
				state.rerenderMfTable++;
				state.isLoading = false;
			}
		};

		const onCellClicked = async (params) => {
			if (params?.createBOM) {
				state.createBOM = params.createBOM;
			} 
			if (params?.type === 'itemPagination') {
				state.page = params.optType.page;
				await BIMPLUSOrderTable.value.refreshTable();
			}
		};
		
		const loadItems = async (order) => {
			// state.showItemTable = !state.showItemTable;
			const selectedRowItem = find(state.creationData, (ord) => ord.itemLoad);
			if (!isEmpty(selectedRowItem) && order.uuid !== selectedRowItem.uuid) selectedRowItem.itemLoad = false;
			order.itemLoad = !order.itemLoad;
			order.itemLoad ? state.loadItemData = order : state.loadItemData = null;
			state.rerenderMfTable++;
		};

		const loadBIMPLUS = async (order, frmGuidLvl = false) => {
			let guidsList = [];
			if(!frmGuidLvl) {
				state.orderForViewer = order;				
				if (!isEmpty(order.items)) {
					for (let item of order.items) {
						for (let guid of item.guids) {
							guidsList.push(guid.guid);
						}
					}
				} else {
					for (let guid of order.guids) {
						guidsList.push(guid.guid);
					}
					if (!isEmpty(order.materials)) {
						for (let material of order.materials) {
							for (let guid of material.guids) {
								guidsList.push(guid.guid);
							}
						}
					}
				}
			} else {
				state.orderForViewer = state.loadItemData;
				guidsList.push(order.guid);
			}

			state.isViewerActive = true;
			state.guids = [];
			guidsList.forEach(((guid) => {
				const guidSplit = guid.split('*');
				state.guids.push(guidSplit[1])
			}));
		};

		const validDate = (date) => {
      if (!date) return undefined;
      date = moment(date);
      if (date.isValid()) return date.toDate();
      return undefined;
    };

    const getMinMaxDate = (key, row, inputProps) => {
      if (!_.isUndefined(inputProps)) {
        const minMax = inputProps[key];
        if (!minMax) return undefined;
				const date = get(row, minMax, undefined);
				if (isEmpty(date)) return undefined;
				return date;
      }
    };

		const minDate = (row, inputProps) => {
      const date = getMinMaxDate('min', row, inputProps);
      return validDate(date);
    };

    const maxDate = (row, inputProps) => {
      const date = getMinMaxDate('max', row, inputProps);
      return validDate(date);
    };


		const diffRowDates = (row, selectedDate, inputProps) => {
      const mindate = minDate(row, inputProps);
      const maxdate = maxDate(row, inputProps);
      if ((moment(selectedDate) >= mindate || !mindate)
      && (moment(selectedDate) <= maxdate || !maxdate)) {
        return true;
      }
      return false;
    };

		const updateDate = async (selectedDate, applyAll, kind, inputProps, alertTitle) => {
			const confirmParam = {
        title: 'ENTERED DATE IS OUT OF RANGE',
        message: `The Entered ${alertTitle} date is out of range for some Orders.
        Enter a new date, or set each Order's date individually.`,
        okButton: 'OK',
      };
			if (applyAll) {
        let invalidDate = false;
        for (const order of state.creationData) {
          const formattedSelectedDate = moment(selectedDate);
          const dateKindDiff = diffRowDates(order, formattedSelectedDate, inputProps);
          const newKind = kind.value.split('.', 2);
          if (dateKindDiff) {
						order[newKind] = moment(selectedDate).toISOString();
          } else if (!invalidDate) {
            invalidDate = true;
          }
        }
        if (invalidDate) DialogProgrammatic.confirm(confirmParam);
      }
			state.refreshCount += 1;
		};

		const setOwner = (rowData, params) => {
			rowData.owner = params.value;
			if (params.applyToAll) {
				for (const order of state.creationData) {
					order.owner = params.value;
				}
				state.refreshOwner += 1;
			}
		};

		const setLocation = (rowData, params) => {
			rowData.location = params.value;
			if (params.applyToAll) {
				for (const order of state.creationData) {
					order.location = params.value;
				}
				state.refreshLocation += 1;
			}
		}

		const updateLvlZone = (rowData, rowField, params) => {
			rowData[rowField.id] = params.value;
			if (params.applyToAll) {
				for (const order of state.creationData) {
					order[rowField.id] = params.value;
				}
				state.refreshlevel += 1;
			}
		}
		
		const objGrpVal = computed(() => {
			if (state.selectedProject?.projectSettings[0]?.bimplusBindings?.groupingProperties[0]?.value) {
				return state.selectedProject?.projectSettings[0]?.bimplusBindings?.groupingProperties[0]?.value;
			}
			return '';
		});

		const itemGrpVal = computed(() => {
			if (state.selectedProject?.projectSettings[0]?.bimplusBindings?.bimplusProperties[0]?.value) {
				return state.selectedProject?.projectSettings[0]?.bimplusBindings?.bimplusProperties[0]?.value;
			}
			return '';
		});

		const modelName = computed(() => {
			if (!isEmpty(state.selectedProject?.projectSettings[0]?.bimplusSync.models)) {
				const bimModel = find(state.selectedProject?.projectSettings[0]?.bimplusSync.models, (model) => model.id === route.query.modelId)
				return bimModel?.name;
			}
			return '';
		});

		const close = () => {
			router.push({path: '/manager/detailing'});
		};

		const editDocs = (rowData) => {
			if (!isEmpty(rowData.identifier)) state.docsOrderTitle = 'Item';
			else state.docsOrderTitle = 'Order';
			state.docsEdit = true;
			state.docs = rowData;
		};

		const closeDocsModal = () => {
			state.docsEdit = !state.docsEdit;
			state.docs = {}
		};

	const turnOffProgress = () => {
		setTimeout(() => {
			state.isProgressBar = false;
			// state.progressCount = 0;
		}, 2000);
	};

	const save = async () => {
		// let errorData;
		// let errorMsg;
		let validData;
		// let orderCreationFailed =  false;
		let identifiersList = [];
		try {
			state.isProgressBar = true;
			let finalData;
			let uniqueOrderIds = [];
			finalData = state.selectedItems;
			for (let data of finalData) {
				if (!isEmpty(data.uniqueOrderId)) uniqueOrderIds.push(data.uniqueOrderId.value);
			}
			uniqueOrderIds = groupBy(uniqueOrderIds, (uniqOrd) => uniqOrd);
			for (let data of finalData) {
				if (!isEmpty(data.items)) {
					for (let item of data.items) {
						if (!isEmpty(item.identifier)) identifiersList.push(toUpper(item.identifier));
						validData = await validateRequiredFields(item, 'item', uniqueOrderIds);
						if (!isEmpty(item.files)) {
							for (let file of item.files) {
								if(!data.files) data.files = [];
								data.files.push(file);
							}
						}
						if (!isEmpty(item.guids)) {
							for (let guid of item.guids) {
								guid.notes = item.notes;
								guid.customId = item.customId;
								guid.level = item.level;
								guid.zone = item.zone;
								guid.installLocs = item.installLocs;
							}
						}
						if (!isEmpty(item.materials)) {
							for (let mat of item.materials) {
								if (!isEmpty(mat.identifier)) identifiersList.push(toUpper(mat.identifier));
							}
						}
					}
				}
				validData = await validateRequiredFields(data, 'order', uniqueOrderIds);
			}
			if (state.invalidData.length) {
				state.isLoading = true;
				state.isInvalidModalActive = true;
				state.isLoading = false;
			}
			let assemblyParts;
			if (state.groupItemBy?.value === 'group-Assemblies' && state.createBOM && !state.invalidData.length) {
				if (state.isSDS2) {
					await BimPlus.addAssemblyParts(finalData);
					assemblyParts = await Catalogs.getAssemblyParts({
					catId: uniq(identifiersList),
					type: 'assemblyAndItems',
					filteredProjects: [props.projectId],
					showAssmbsParts: true,
				});}
			}
			for (let order of finalData) {
				if (state.isSDS2 && !isEmpty(order.items)) {
					order.items.map((item) => {
						let catalogAssembly = find(assemblyParts.data, (catalog) => toUpper(catalog.identifier) === toUpper(item.identifier));
						item.catId = catalogAssembly.catId;
						if (!isEmpty(item.materials)) item.materials.map((mat) => {
							let catalogPart = find(assemblyParts.data, (catalog) => toUpper(catalog.identifier) === toUpper(mat.identifier));
							mat.catId = catalogPart.catId;
						})
					});
				}
				if (!state.invalidData.length) {
					if(!isEmpty(order.template)) {
						delete order.template;
					}
					order.access_token = store.state.bimplus.access_token;
					order.team_slug = get(state.selectedProject, 'projectSettings[0].bimplusSync.team.id', '');
					order.bimProjectId = get(state.selectedProject, 'projectSettings[0].bimplusSync.project.id', '');
					order.createBom = state.createBOM;
					const newCard = await ProductionManager.createOrderFromTemplate(order);
					// try {
					// } catch (error) {
					// 	console.log('error:', error);
					// 	errorData = JSON.parse(error.config.data);
					// 	errorMsg = error.data.msg;
					// 	validData = validateRequiredFields(errorData, {}, 'error', {}, errorMsg);
					// 	orderCreationFailed = true
					// }
					state.progressCount += 1;
				}
			}
		} catch (error) {
			console.log('error:', error);
			state.hasErrorOccured = true;
		} finally {
			// if (orderCreationFailed) state.hasErrorOccured = true;
			if (!state.hasErrorOccured && !state.invalidData.length) {
				toast.success('Order/s Successfully Created')
				router.push({path: '/manager/detailing'})
			} else if (state.hasErrorOccured) {
				// turnOffProgress();
				// if (state.invalidData.length) {
				// 	state.isLoading = true;
				// 	state.isInvalidModalActive = true;
				// 	state.isLoading = false;
				// }
			}
		}
	};

	emitter.on('opened-row', (e) => {
		const tableData = BIMPLUSItemTable?.value?.tableData;
		const idx = findIndex(tableData, { name: e.name });
		Object.assign(BIMPLUSItemTable?.value?.tableData[idx], e);
	});

  const onTemplateChange = (rowData, params) => {
		const { value: selectedTemplate, applyToAll } = params;
		if(!isEmpty(selectedTemplate)) {
			if (applyToAll) {
				for (let order of state.creationData) {
					if (!isEmpty(rowData.identifier) || (!isEmpty(rowData.guids) && !state.isSDS2)) {
						for (let item of order.items) {
							item.templateId = selectedTemplate?._id;
							item.templateName = selectedTemplate?.name;
							item.template = selectedTemplate;
						}
					} else {
						if (!isEmpty(get(selectedTemplate, 'financialId', ''))) order.financialId = get(selectedTemplate, 'financialId', '');
						if (!isEmpty(get(selectedTemplate, 'level', ''))) order.level = get(selectedTemplate, 'level', '');
						if (!isEmpty(get(selectedTemplate, 'zone', ''))) order.zone =  get(selectedTemplate, 'zone', '');
						order.templateOrder = selectedTemplate?._id;
						if (!isEmpty(selectedTemplate?.owner)) order.owner = selectedTemplate?.owner;
						if (!isEmpty(get(selectedTemplate, 'manager.location', {}))) order.location = get(selectedTemplate, 'manager.location', {});
						order.template = selectedTemplate;
						if (!every(selectedTemplate.leadDates, (value) => value === null)) {
							order.poDetailBy = '';
							order.disableDetailBy = true;
						} else order.disableDetailBy = false;
					}
				}
			} else {
				if (!isEmpty(rowData.identifier) || (!isEmpty(rowData.guids) && !state.isSDS2)) {
					rowData.templateId = selectedTemplate?._id;
					rowData.templateName = selectedTemplate?.name;
					rowData.template = selectedTemplate;
				} else {
					if (!isEmpty(get(selectedTemplate, 'financialId', ''))) rowData.financialId = get(selectedTemplate, 'financialId', '');
					if (!isEmpty(get(selectedTemplate, 'level', ''))) rowData.level = get(selectedTemplate, 'level', '');
					if (!isEmpty(get(selectedTemplate, 'zone', ''))) rowData.zone =  get(selectedTemplate, 'zone', '');
					rowData.templateOrder = selectedTemplate?._id;
					if (!isEmpty(selectedTemplate?.owner)) rowData.owner = selectedTemplate?.owner;
					if (!isEmpty(get(selectedTemplate, 'manager.location', {}))) rowData.location = get(selectedTemplate, 'manager.location', {});
					rowData.template = selectedTemplate;
					if (!every(selectedTemplate.leadDates, (value) => value === null)) {
						rowData.poDetailBy = '';
						rowData.disableDetailBy = true;
					} else rowData.disableDetailBy = false;
				}
			}
			state.refreshTemplate += 1;
    }
  };

	const loadInvalidData = () => state.invalidData;

	const closeInvalidListModal = () => {
		state.isProgressBar = false;
		state.invalidData = [];
		state.isInvalidModalActive = false;
		state.invalidRefreshKey++;
	};

	const dateDisable = (rowData, rowField) => {
		if (rowField.prop === 'poDetailBy' && rowData.disableDetailBy) return true;
		return false;
	}

	const validateRequiredFields = async (obj, type, uniqueOrderIds, errorMsg) => {
		const errors = [];
		const orderName = obj.name?.toString() ?? "";
		const addError = (msg) => errors.push(msg);

		if (type === "item") {
			if (orderName.length < 3) addError("<p>Item name is mandatory and should be at least 3 characters long</p>");
		} else if (type === "error") {
			if (errorMsg) addError(errorMsg);
		} else {
			if (orderName.length < 3) addError("<p>Order name is mandatory and should be at least 3 characters long</p>");

			const uniqueOrderId = obj.uniqueOrderId?.value.toString() || "";
			if (uniqueOrderId) {
				if (uniqueOrderId.length < 4 || uniqueOrderId.length > 24) addError("<p>Order Id must be in range of 4-24 characters</p>");
				if (!Validation.validateUniqueOrderId(uniqueOrderId)) addError("<p>Order Id Contains Invalid Characters</p>");
				if (uniqueOrderIds[uniqueOrderId] && uniqueOrderIds[uniqueOrderId].length !== 1) addError("<p>Duplicate Order Id Entry</p>");
			}

			if (obj.financialId) {
				const cleanedFinancialId = obj.financialId
					.toString()
					.trim()
					.replace(/ /g, ".")
					.toUpperCase();
				if (!Validations.validateOrderId(cleanedFinancialId)) addError("<p>Description length must be 4 to 24 characters long and cannot start or end with special characters</p>");
			}

			let allProjectLocations = await Locations.allLocationForUser({
				projectId: state.selectedProject._id,
			});

			if (isEmpty(obj.location)) addError("<p>Location is required</p>");
			else if (!find(allProjectLocations, (loc) => loc._id === obj.location._id)) addError("<p>Invalid Location entry</p>");

			if (!obj.templateOrder && !obj.poDetailBy) addError("<p>Detailby Date is required</p>");
			if (!obj.deliver) addError("<p>Onsite Date is required</p>");
		}
		if (errors.length) {
			state.invalidData.push({
				_isValid: false,
				_errorMsg: errors.join(""),
				name: obj.name,
			});
			return null;
		}
		return obj;
	};

	const openBIMPLUS = () => {
		return `https://portal${urls.bimplusEnvironment !== 'prod' ? '-stage' : ''}.bimplus.net/viewer/#/viewer?project_id=${get(state.selectedProject, 'projectSettings[0].bimplusSync.project.id', '')}&team_id=${get(state.selectedProject, 'projectSettings[0].bimplusSync.team.id', '')}`;
	};

	onBeforeMount(async () => {
		state.isLoading = true;
		try {
			state.selectedProject = await Projects.get(props.projectId);
			if (isEmpty(state.selectedProject)) return toast.error("Project Not Found");
			state.team_slug = get(state.selectedProject, 'projectSettings[0].bimplusSync.team.id', '');
			({ templateProject: state.templateProject } = (await Projects.haveTemplateProject()));
			state.isSDS2 = get(state.selectedProject, 'projectSettings[0].bimplusSync.modelSource', '') === 'SDS2';
			state.createBOM = state.isSDS2;
			if (state.isSDS2) state.groupItemBy = itemGroupingOpts[2];
			const divisionTopologyId = route.query.divisionTopologyId;
			const [eData, prodTemp, matTemp, userList, locsList] = await Promise.all([
				bimplusViewer.getElementDetails(divisionTopologyId, store.state.bimplus.access_token, state.team_slug),
				state.templateProject?._id 
					? SupplyChain.supplyChain({
							projectId: state.templateProject._id,
							module: 'ProdTemplates',
							filterNoItemOrders: false,
							limit: 9999,
							page: 1,
						})
					: Promise.resolve({ data: [] }),
				state.templateProject?._id
					? SupplyChain.supplyChain({
							projectId: state.templateProject._id,
							module: 'MatTemplates',
							filterNoItemOrders: false,
							limit: 9999,
							page: 1,
						})
					: Promise.resolve({ data: [] }),
				Projects.linkedProjectUsers([props.projectId]),
				getAllLocations(props.projectId, true),
			]);
			state.elementsData = eData;
			if (!isEmpty(state.selectedProject) && !isEmpty(state.elementsData)) state.rerenderOrderMfTable++;
			state.templateOrders = prodTemp.data;
			state.matTemplateOrders = matTemp.data.map((order) => {
				if (!isEmpty(order)) { return {_id: order._id, name: order.templateName }; }
				else { return []; };
			});
			let users = userList;
			state.selectedProjectUser = find(users, (usr) =>
				usr.company === get(store.state.userData,'company._id', store.state.userData.company)
			)
			state.allUsers = users;
			const loc = locsList;
			state.allLocations = loc;
			state.allLocations = filter(state.allLocations, (loc) =>
				loc.company._id.toString() === store.state.userData.company.toString()
			)
		} catch (error) {
			console.log('error:', error)
		} finally {
			state.isLoading = false;
			state.dataLoaded = true;
		}
	});

	const closeViewer = () => {
		state.isViewerActive = false;
		state.guids = [];
	};

	emitter.on('isolateFromGuidLvl', async (rowData) => {
		await loadBIMPLUS(rowData, true);
	});
		
		return {
			...toRefs(state),
			loadData,
			onCellClicked,
			loadItemsData,
			loadItems,
			turnOffProgress,
			save,
			getSelectedRows,
			itemGroupingOpts,
			BIMPLUSOrderTable,
			BIMPLUSItemTable,
			loadBIMPLUS,
			objGrpVal,
			modelName,
			close,
			editDocs,
			closeDocsModal,
			itemGrpVal,
      onTemplateChange,
			closeViewer,
			openBIMPLUS,
			objectGroupingOpts,
			groupItem,
			groupOrder,
			loadInvalidData,
			closeInvalidListModal,
			validateRequiredFields,
			invalidListCols,
			updateDate,
			dateDisable,
			diffRowDates,
			minDate,
			maxDate,
			setOwner,
			setLocation,
			updateLvlZone,
		};
	}
}
</script>
<style>
::v-deep(.o-table tbody) {
min-height: 385px !important;
max-height: 385px !important;
}
</style>